import {
  calculateBillingAddress,
  calculatePolicyholder,
  focusOnError,
  updateCountry,
} from '@qover/organisms';

export const bikeDecorators = () => [
  calculateBillingAddress,
  calculatePolicyholder,
  focusOnError,
  updateCountry,
];
